import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class SilentAuthService {

  constructor(private httpClient: HttpClient) {
  }

  public retrieveJwtToken(): Observable<string> {
    const silentAuthUrl = 'http://localhost:83/silent-auth/jwt-redirect/private/jwt-service';
    return this.httpClient.get(silentAuthUrl, {
      responseType: 'text',
      withCredentials: true
    });
  }
}
